import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import { useNavigate } from "react-router-dom";
import WebBanner1 from '../../assets/images/Banner/web/banner1.png';

import WebBanner3 from '../../assets/images/Banner/web/banner3.png';
import MobileBanner3 from '../../assets/images/Banner/mobile/banner3.png';
import MobileBanner1 from '../../assets/images/Banner/mobile/banner1.png';
import { boxClasses, Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const imaged = [
    {
    label: 'event/202601',
    imgPath: WebBanner1,
  }, 
  {
    label: 'collections',
    imgPath: WebBanner3,
  }
];

const imageh = [
      {
    label: 'event/202601',
    imgPath: MobileBanner1,
  }, 
  {
    label: 'collections',
    imgPath: MobileBanner3,
  }
];

function SwipeableTextMobileStepper() {
   const { t, i18n } = useTranslation();
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = imaged.length;
const currentLang = i18n.language;
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const navigate = useNavigate()

  const gotToNewPage=(path)=>{
    console.log(path);
    navigate(path);
  }

  return (
    <Stack direction="row" justifyContent="center"  sx={{width: "100%", flexGrow: 1 }}>

      <Stack direction="column" width= {{lg:"90%", md:"100%"}}  justifyContent={"center"}   > 
      <Stack direction="column" display={{lg:"flex", md:"none", xs:"none"}} width="100%" >
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents={false}
        sx={{justifyContent: "center"}}> 
  
         {imaged.map((step, index) => (
        <div key={step.label}>
          {Math.abs(activeStep - index) <= 2 ? (
            <Box component="img"justifyContent = 'center' sx={{mx:'auto', height: "90vh", display: 'block', width: "auto", overflow: 'hidden',}}
                src={step.imgPath}
                alt={step.label}
                onClick={() => gotToNewPage(`/${currentLang}/`+step.label)}
            />
            ) : null}
          </div>
        ))}            
      </AutoPlaySwipeableViews>
      <Stack direction="row" justifyContent="center">
      <MobileStepper steps={maxSteps}
       
        activeStep={activeStep}
      
        sx={{
          justifyContent:"center",
          position:"relative",
          top:"-5vh",
          zIndex:"5",
          width:"95%",
          bgcolor: 'transparent',
          "& .MuiMobileStepper-dot": {
            backgroundColor: "primary.white",
            height: "1vh",
            margin: "1vh",
            width: "1vh",
          },
          "& .MuiMobileStepper-dotActive": {
            backgroundColor: "primary.red"
          }
        }}
      />
      </Stack>
      </Stack>


      <Stack direction="column" display={{lg:"none", md:"flex", xs:"flex"}} width="100%" height="auto">
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >       
        {imageh.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
  sx={{
    display: 'flex',              // 開啟 flex 排版
    justifyContent: 'center',     // 水平置中（圖片本來就是 100%，其實可省）
    alignItems: 'center',         // 垂直置中
    width: '100%',
    height: '90vh',               // 固定容器高度
    overflow: 'hidden',
  }}
>
              <Box
                component="img"
                sx={{
                  
                  display: 'block',
                  overflow: 'hidden',
                  width: "100%",
                   maxHeight: "90vh",         // 限制最大高度
    objectFit: "cover",        // 保持圖片比例並裁切多餘部分
                }}
                src={step.imgPath}
                alt={step.label}
                onClick={() => gotToNewPage(`/${currentLang}/`+step.label)}
              />
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <Stack direction="row" justifyContent="center">
      <MobileStepper steps={maxSteps}
       
        activeStep={activeStep}
        sx={{
          justifyContent:"center",
          position:"relative",
          top:"-5vh",
          zIndex:"5",
          width:"96%",
          bgcolor: 'transparent',
          "& .MuiMobileStepper-dot": {
            backgroundColor: "primary.white",
            height: "1vh",
            margin: "1vh",
            width: "1vh",
          },
          "& .MuiMobileStepper-dotActive": {
            backgroundColor: "primary.red"
          }
        }}
      />
      </Stack>
      </Stack>

<Stack direction="row" width="100%" justifyContent="space-between">
      
      <Box  display={{lg:"flex", md:"none", xs:"none"}} direction="row" height="5vw"  position="relative" top="-55vh" >
        <Button  zIndex={5} sx={{bgcolor:"#0f0f0f", opacity:"20%"}} onClick={handleBack} disabled={activeStep === 0}>
          {theme.direction === 'rtl' ? (<KeyboardArrowRight color='primary.white' />) : (<KeyboardArrowLeft sx={{color:"#ffffff"}}/>)}
        </Button>
        </Box>
        <Box display={{lg:"flex", md:"none" , xs:"none"}} direction="row-reverse" height="5vw" position="relative" top="-55vh" >
        <Button zIndex={5} sx={{bgcolor:"#0f0f0f", opacity:"20%"}} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
          {theme.direction === 'rtl' ? (<KeyboardArrowLeft color='primary.white' />) : (<KeyboardArrowRight sx={{color:"#ffffff"}} />)}
        </Button>
      </Box>

    </Stack>

      </Stack>

  
     
    </Stack>
         


  );
}

export default SwipeableTextMobileStepper;
